import React from 'react';
import PhonicsReview from './phonics/PhonicsReview';
import letterDataOoYY from './phonics/phonics_data_oo_yy';

function PhonicsOoYY() {
  return <PhonicsReview data={letterDataOoYY} />;
}

export default PhonicsOoYY;
